module.exports = __webpack_public_path__ + "img/icone-agro-settings.d61921fe.svg";